import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCurrentRole, getOnBoardingAPIData, getOnBoardingAPIStatus, setCurrentRole } from 'src/slices/onBoardingSlice';
import { tagEvent, TAG_EVENT_CONST, setUserRole } from 'src/utils/analytics/analytics.service.util';
import { USER_ROLE, RouteConstants } from '../../constants/constants';
import { IRoleSwitchModel } from '../../../src/models/IAllOpportunitiesModel';
import { Select } from "@scuf/common";
import { clearAllFilters, setPaginationCurrentPage } from '../../slices/allOpportunitySlice';
import { setOverviewViewType } from 'src/slices/overviewSlice';
import { useNavigate } from "react-router-dom";

const HeaderDropdown = (props: any) => {
    const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
    const userOnboardData = useSelector(getOnBoardingAPIData);
    const dispatch = useDispatch();
    const navigate =  useNavigate();
    const currentRole = useSelector(getCurrentRole);

    const [userRoles, setUserRoles] = useState<IRoleSwitchModel[]>([]);

    const isnullorempty = (value: string) => {
        if(value === null || value === undefined || value === ''){
            return true
        }
        else{
            return false
        }
    }

    useEffect(() => {
        if (userOnboardAPIStatus === 'finished' && userOnboardData) {
            userOnboardData && userOnboardData?.roles && isnullorempty(currentRole) && dispatch(setCurrentRole(userOnboardData.roles[0]));
            userOnboardData && userOnboardData?.roles && isnullorempty(currentRole) && tagEvent(TAG_EVENT_CONST.role, { UserRole: userOnboardData.roles[0] });
            const roleSwitchOptions = [] as any;
            userOnboardData.roles?.map((value) => {
                if (value === USER_ROLE.ORG_USER) {
                roleSwitchOptions.push({ value: USER_ROLE.ORG_USER, text: "Org Owner" });
                } else if (value === USER_ROLE.DOMAIN_FOCAL) {
                roleSwitchOptions.push({ value: USER_ROLE.DOMAIN_FOCAL, text: "Domain Focal" });
                } else if (value === USER_ROLE.LEADERSHIP_USER) {
                roleSwitchOptions.push({ value: USER_ROLE.LEADERSHIP_USER, text: "Leadership" });
                }
                 else if (value === USER_ROLE.POWER_USER) {
                roleSwitchOptions.push({ value: USER_ROLE.POWER_USER, text: "Power User" });
                }
                 else if (value === USER_ROLE.REVIEWER) {
                roleSwitchOptions.push({ value: USER_ROLE.REVIEWER, text: "Reviewer" });
                } else if (value === USER_ROLE.VIEWER) {
                roleSwitchOptions.push({ value: USER_ROLE.VIEWER, text: "Viewer" });
                }
                else if (value === USER_ROLE.MODEL_POWER_USER) {
                roleSwitchOptions.push({ value: USER_ROLE.MODEL_POWER_USER, text: "Model Owner" });
                }
                else if (value === USER_ROLE.MODEL_LABELER) {
                roleSwitchOptions.push({ value: USER_ROLE.MODEL_LABELER, text: "Labeler" });
                }
                else if (value === USER_ROLE.MODEL_FUNCTIONAL_LEADERSHIP) {
                roleSwitchOptions.push({ value: USER_ROLE.MODEL_FUNCTIONAL_LEADERSHIP, text: "Functional Leadership" });
                }
                setUserRoles(roleSwitchOptions);
            })
        }
    }, [userOnboardAPIStatus]);
    console.log(currentRole)

    const roleSwitchHandle = (value: string) => {
        dispatch(clearAllFilters([]));
        dispatch(setPaginationCurrentPage(1));
        dispatch(setOverviewViewType(""));
        // if (value === USER_ROLE.ORG_USER || value === USER_ROLE.REVIEWER || value === USER_ROLE.VIEWER) {
        //   dispatch(setActiveDashboardTab(DASHBOARD_TABS.ALL_OPPORTUNITIES));
        //   navigate(RouteConstants.DASHBOARD);
        // } else {
        //   dispatch(setActiveDashboardTab(DASHBOARD_TABS.OVERVIEW));
        //   navigate(RouteConstants.HOME);
        // }
    
              // dispatch(setActiveDashboardTab(DASHBOARD_TABS.OVERVIEW));
        navigate(RouteConstants.LANDING_PAGE);
        dispatch(setCurrentRole(value));
        setUserRole(value);
        tagEvent(TAG_EVENT_CONST.role, { UserRole: value });
      }
  

  return(
        <span>{userOnboardData && userOnboardData.roles && userOnboardData.roles?.length > 1 //&& userOnboardData.roles?.find((value) => { return value === USER_ROLE.ORG_USER || value === USER_ROLE.REVIEWER || value === USER_ROLE.VIEWER||value === USER_ROLE.MODEL_POWER_USER })
          && 
          <Select className='custom-select role-switch'
            placeholder={userRoles?.length > 0 ? userRoles[0].text : ''}
            options={userRoles}
            value={currentRole}
            onChange={roleSwitchHandle} />}
          </span>
  )
}

export default HeaderDropdown